import React, { Component } from 'react';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal } from 'antd';
import axios from 'axios';
import { toUpperKey } from '../../../../util/helpper';
import moment from 'moment';
import ScrollToTop from '../../../../components/ScrollToTop';
import MenuSider from '../../../../components/MenuSider';

const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { confirm } = Modal;

class SOTEditData extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            validated: false,
            isLoading: true,
            observations: [],
            optStatusNames:[],
            criteria: {
                "observation_DateFrom": undefined,
                "observation_DateTo": undefined,
                "userFullNameLike": undefined,
                "email_AddressLike": undefined,
                "currentStatusNames": [],
                "createDateFrom": undefined,
                "createDateTo": undefined
            }
        }
    }

    componentDidMount() {

        this.setState({ isLoading: true }, () => {
            
            this.getTokenHeader().then(tokenHeader => {
                const $optStatusName = axios.get("api/ObservationAdmin/OptStatusName", tokenHeader).then(statusNameResp => {
                    this.setState({
                        optStatusNames: statusNameResp.data
                    })
                });

                Promise.all([$optStatusName]).then(() => {
                    this.setState({ isLoading: false });
                });
            });
        });
    }

    onObservationDateChange = (date, dateString) => {
        var criteria = this.state.criteria;

        if (date[0]) {
            criteria.observation_DateFrom = date[0].format('YYYY-MM-DDT00:00:00Z');
        }
        else {
            criteria.observation_DateFrom = undefined;
        }

        if (date[1]) {
            criteria.observation_DateTo = date[1].format('YYYY-MM-DDT00:00:00Z');
        }
        else {
            criteria.observation_DateTo = undefined;
        }
    }

    onCreateDateChange = (date, dateString) => {
        var criteria = this.state.criteria;

        if (date[0]) {
            criteria.createDateFrom = date[0].format('YYYY-MM-DDT00:00:00Z');
        }
        else {
            criteria.createDateFrom = undefined;
        }

        if (date[1]) {
            criteria.createDateTo = date[1].format('YYYY-MM-DDT00:00:00Z');
        }
        else {
            criteria.createDateTo = undefined;
        }
        this.setState({ criteria: { ...criteria } });
    }

    onOptStatusChange = (values, options) => {
        var criteria = this.state.criteria;

        if (values) {
            criteria.currentStatusNames = values;
        }
        else {
            criteria.currentStatusNames = [];
        }
        this.setState({ criteria: { ...criteria } });
    }

    onCriteriaInputChange = (value, attributeName) => {
        var criteria = this.state.criteria;
        criteria[attributeName] = value;
        this.setState({ criteria: { ...criteria } });
    }

    onClickToEditRow = (pkObTranID) => {
        this.props.history.push({
            pathname: "/observation/request/" + pkObTranID
        })
    }

    onClickToDeleteRow = (pkObTranID) => {

        confirm({
            title: 'Do you want to delete these items?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                this.setState({
                    isLoading: true,
                }, () => {
                    this.getTokenHeader().then(tokenHeader => {
                        axios.get("api/ObservationTransactionV2/Delete?id=" + pkObTranID, tokenHeader).then(() => {

                            this.setState({
                                isLoading: false
                            });

                            Modal.success({
                                content: 'This record has been deleted.',
                                onOk: () => {
                                    this.query();
                                }
                            });
                        });
                    });
                });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    query = () => {
        this.setState({
            isLoading: true,
            validated: true
        }, () => {

            this.getTokenHeader().then(tokenHeader => {

                const req = this.state.criteria;

                if (!req.observation_DateFrom || !req.observation_DateTo) {
                    Modal.error({
                        title: 'Error!',
                        content: 'Please select observation date!',
                    });
                    this.setState({ isLoading: false });
                    return;
                }

                const observation_DateFromMoment = moment(req.observation_DateFrom, 'YYYY-MM-DDT00:00:00Z');
                const observation_DateToMoment = moment(req.observation_DateTo, 'YYYY-MM-DDT00:00:00Z');
                const diffOffDay = observation_DateToMoment.diff(observation_DateFromMoment, 'days');
                //if (diffOffDay > 7) {
                //    Modal.error({
                //        title: 'Error!',
                //        content: 'The observation date no more than 7 days!',
                //    });
                //    this.setState({ isLoading: false });
                //    return;
                //}

                if (!req.userFullNameLike && !req.email_AddressLike) {
                    Modal.error({
                        title: 'Error!',
                        content: 'Please enter creator name (EN/TH) or creator e-mail!',
                    });
                    this.setState({ isLoading: false });
                    return;
                }

                console.debug("SOTEditData > query() > req:", req);

                axios.post("api/ObservationAdmin/Query", req, tokenHeader).then((rowItemResp) => {
                    this.setState({
                        observations: rowItemResp.data,
                        isLoading: false
                    });
                });
            });
        });
    }

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        return (<>
            <ScrollToTop />
            <Spin tip="Loading..." spinning={this.state.isLoading}>
                <MenuSider title="System Management > SOT Edit Data">
                    <Content style={{ margin: '16px 0 0 16px' }}>
                        <Collapse expandIconPosition="right" defaultActiveKey="1">
                            <Panel header={<><Icon type="filter" /> Filter</>} key="1">
                                <Row>
                                    <Col xs={24} sm={24} md={23} lg={12}>
                                        <Form.Item label="Observation Date" required={true} validateStatus={(this.state.validated && !this.state.criteria.observation_DateFrom) ? "error" : "success"}>
                                            <RangePicker onChange={this.onObservationDateChange} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={23} lg={12}>
                                        <Form.Item label="Created Date">
                                            <RangePicker onChange={this.onCreateDateChange} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={23} lg={12}>
                                        <Form.Item label="Creator Name (EN/TH)" required={true} validateStatus={(this.state.validated && !this.state.criteria.userFullNameLike) ? "error" : "success"}>
                                            <Input placeholder="Creator Name (EN/TH)" onChange={(e) => this.onCriteriaInputChange(e.target.value, "userFullNameLike")} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={23} lg={12}>
                                        <Form.Item label="Creator E-Mail">
                                            <Input placeholder="Creator E-Mail" onChange={(e) => this.onCriteriaInputChange(e.target.value, "email_AddressLike")} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={23} lg={12}>
                                        <Form.Item label="Status">
                                            <Select
                                                mode="multiple"
                                                allowClear={true}
                                                style={{ width: '100%' }}
                                                placeholder="Please select"
                                                onChange={this.onOptStatusChange}
                                            >
                                                {this.state.optStatusNames.map(optStatusName => {
                                                    return <Option key={optStatusName} value={optStatusName}>{optStatusName}</Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: "right" }}>
                                        <Button onClick={this.query}><Icon type="search" />Search</Button>
                                    </Col>
                                </Row>
                            </Panel>
                        </Collapse>
                        <br />
                        <Table dataSource={this.state.observations}
                            size="small"
                            bordered={true}
                            rowKey="pkObTranID">
                            <Column dataIndex="pkObTranID" title="" align="center"
                                render={(text, record) => {
                                    return <>
                                        <a target="_blank" href={"observation/request/" + record.pkObTranID}><Button size="small"><Icon type="edit" /></Button></a>&nbsp;
                                        <Button size="small" type="danger" onClick={() => { this.onClickToDeleteRow(record.pkObTranID); }}><Icon type="delete" /></Button>
                                    </>
                                }}
                            />
                            <Column dataIndex="observation_Date" title="Observation Date" align="center"
                                defaultSortOrder="descend"
                                sorter={(a, b) => {
                                    return (!a.observation_Date ? "" : a.observation_Date).localeCompare(b.observation_Date)
                                }}
                                render={(text, record) => {
                                    return <>{moment(text, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DD')}</>
                                }}
                            />
                            <Column dataIndex="observation_Time" title="Observation Time" align="center"/>
                            <Column dataIndex="userFullName_ENG" title="Creator" align="left"
                                sorter={(a, b) => {
                                    return (!a.userFullName_ENG ? "" : a.userFullName_ENG).localeCompare(b.userFullName_ENG)
                                }}
                            />
                            <Column dataIndex="currentStatusName" title="Status" align="left"
                                sorter={(a, b) => {
                                    return (!a.currentStatusName ? "" : a.currentStatusName).localeCompare(b.currentStatusName)
                                }}
                            />
                        </Table>
                    </Content>
                </MenuSider>
            </Spin>
        </>)
    }
}

export default SOTEditData;